import React, { useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Search, X, Link2 } from "lucide-react";

export const MoederKoppeling = ({ ownSku, value, onChange }) => {
  const [q, setQ] = useState("");
  const [results, setResults] = useState([]);
  const [open, setOpen] = useState(false);
  const tmr = useRef(null);

  useEffect(() => {
    clearTimeout(tmr.current);
    if (!q || q.length < 2) { setResults([]); return; }
    tmr.current = setTimeout(async () => {
      const { data } = await api.get("/producten", { params: { q } });
      setResults((data || []).filter((p) => p.sku !== ownSku).slice(0, 6));
    }, 250);
    return () => clearTimeout(tmr.current);
  }, [q, ownSku]);

  return (
    <div data-testid="moeder-koppeling">
      <Label className="text-xs text-muted-foreground">Moederproduct (koppel op artikelcode)</Label>
      {value ? (
        <div className="flex items-center gap-2 mt-1 rounded-md border border-border bg-secondary/40 px-3 py-2">
          <Link2 className="h-4 w-4 text-primary shrink-0" />
          <span className="font-mono text-xs">{value}</span>
          <Button size="icon" variant="ghost" className="h-6 w-6 ml-auto" onClick={() => onChange("")} data-testid="moeder-clear">
            <X className="h-3 w-3" />
          </Button>
        </div>
      ) : (
        <div className="relative mt-1">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
          <Input className="pl-9" placeholder="Zoek moeder op artikelcode of naam…"
            value={q} onChange={(e) => { setQ(e.target.value); setOpen(true); }}
            data-testid="moeder-search" />
          {open && results.length > 0 && (
            <div className="absolute z-20 mt-1 w-full bg-card border border-border rounded-lg shadow-lg overflow-hidden">
              {results.map((p) => (
                <button key={p.id} type="button"
                  className="flex items-center gap-2 w-full text-left px-3 py-2 text-sm hover:bg-secondary"
                  onClick={() => { onChange(p.sku); setQ(""); setResults([]); setOpen(false); }}
                  data-testid={`moeder-opt-${p.sku}`}>
                  <span className="font-mono text-xs text-muted-foreground">{p.sku}</span>
                  <span className="truncate">{p.naam}</span>
                </button>
              ))}
            </div>
          )}
        </div>
      )}
      <p className="text-[11px] text-muted-foreground mt-1">Omzet van dit product telt in het Dashboard mee onder de moeder.</p>
    </div>
  );
};
